module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("I’d like to dedicate this book to Ron Goulart")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("Mining the words out of a rich vein of plot")]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("a miner, but no minor, his face blackened")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("with printer’s ink, his fingers blue with")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("bruises from the keyboard")]), _vm._v("—"), _c('i', [_vm._v("he toils in")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("unrecognized effort. Hail to you, Ronald, a")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("writer of minor physique but of major talent")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 72
// module chunks = 0